

















































































































import { Component, Prop, Vue, PropSync } from "vue-property-decorator";
import { ReferenceItem } from "@/services/types";
import RangeSlider from "@/components/form/input/RangeSlider.vue";
import { BUYER_ANALYTICS_MONEY_RANGE_VALUES, CURRENCY } from "@/constants";
import { formatPriceRange } from "@/utils/string";
import { OptionItem } from "@/services/types";
import Project from "@/entity/Project";

@Component({
  components: {
    RangeSlider,
  },
})
export default class BuyerAnalyticsFormFilter extends Vue {
  @Prop({ type: Array, required: true }) regions!: ReferenceItem[];
  @Prop({ type: Array, required: true }) industries!: ReferenceItem[];
  @Prop({ type: Array, required: true }) subIndustries!: ReferenceItem[];
  @Prop({ type: Array, required: true }) buyerTypes!: ReferenceItem[];
  @Prop({ type: Array, required: true }) buyerStatuses!: OptionItem[];
  @Prop({ type: Array, required: true }) projects!: Project[];

  @PropSync("selectedRegions", { type: Array, required: true })
  selectedRegionsLocal!: ReferenceItem[];
  @PropSync("selectedIndustries", { type: Array, required: true })
  selectedIndustriesLocal!: ReferenceItem[];
  @PropSync("selectedSubIndustries", { type: Array, required: true })
  selectedSubIndustriesLocal!: ReferenceItem[];
  @PropSync("selectedRange", { type: Array, required: true })
  selectedRangeLocal!: [number, number];
  @PropSync("selectedBuyerType", { type: Array, required: false })
  selectedBuyerTypeLocal!: ReferenceItem[];
  @PropSync("selectedBuyerStatus", { type: Array, required: false })
  selectedBuyerStatusLocal!: ReferenceItem[];
  @PropSync("selectedProjects", { type: Array, required: false })
  selectedProjectsLocal!: Project[];

  BUYER_ANALYTICS_MONEY_RANGE_VALUES = BUYER_ANALYTICS_MONEY_RANGE_VALUES;

  get rangePrice(): string {
    if (this.selectedRangeLocal) {
      return formatPriceRange(
        this.BUYER_ANALYTICS_MONEY_RANGE_VALUES[this.selectedRangeLocal[0]],
        this.BUYER_ANALYTICS_MONEY_RANGE_VALUES[this.selectedRangeLocal[1]],
        CURRENCY
      );
    }
    return "";
  }

  reset(name: string) {
    (this.$refs[name] as any).lazySearch = "";
  }
}
